import React, { useState } from 'react';
import { Card, InputNumber, Button, Typography, message } from 'antd';
import { isAdmin } from 'components/AdminOnly';
import { useAppSelector } from 'hooks';
import firebase from '../../../firebase';
import { EditOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface Props {
  orgId: string;
  sensorId: string;
  initialValue?: number;
}

const DosagePercentage: React.FC<Props> = ({ orgId, sensorId, initialValue = 0 }) => {
  const userId = useAppSelector((state) => state.user.details.uid);
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(initialValue);
  const [loading, setLoading] = useState(false);

  const canEdit = isAdmin(userId);

  const handleSave = async () => {
    setLoading(true);
    try {
      await firebase.firestore().collection(`orgs/${orgId}/sensors`).doc(sensorId).update({
        dosagePercentage: value,
      });
      message.success('Dosering opdateret');
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating dosage:', error);
      message.error('Kunne ikke opdatere dosering');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Dosering" size="small" className="w-full">
      <div className="flex items-center justify-between">
        {isEditing ? (
          <div className="flex items-center gap-2">
            <InputNumber
              min={0}
              max={100}
              value={value}
              onChange={(val) => setValue(val || 0)}
              formatter={(value) => `${value}%`}
              parser={(value) => parseFloat(value!.replace('%', ''))}
            />
            <Button
              type="primary"
              icon={<SaveOutlined />}
              onClick={handleSave}
              loading={loading}
              size="small"
            />
            <Button
              icon={<CloseOutlined />}
              onClick={() => {
                setValue(initialValue);
                setIsEditing(false);
              }}
              size="small"
            />
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <Text className="text-xl font-bold">{value}%</Text>
            {canEdit && (
              <Button
                type="text"
                icon={<EditOutlined />}
                onClick={() => setIsEditing(true)}
                size="small"
              />
            )}
          </div>
        )}
      </div>
    </Card>
  );
};

export default DosagePercentage;
